import React, { useContext, useState } from 'react';

import { MenuContext } from '../../../MenuContext';
import { UtilsContext } from '../../../UtilsContext';
import { ResultsContext } from '../../../ResultsContext';

import DashboardDataset from '../DataSets/Dashboard/DashboardDataset';
import AdoptionDashboard from '../DataSets/AdoptionDashboard/AdoptionDashboard';
import ChangeLogsDataset from '../DataSets/ChangeLogs/ChangeLogsDataset';
import SelectionRunLogsDataSet from '../DataSets/SelectionRunLogs/SelectionRunLogsDataSet';
import OrganisationsDataset from '../DataSets/Organisations/OrganisationsDataset';
import AdminUsersDataset from '../DataSets/AdminUsers/AdminUsersDataset';
import UsersDataset from '../DataSets/Users/UsersDataset';
import NotificationsDataset from '../DataSets/Notifications/NotificationsDataset';
import Alerts from '../DataSets/Alerts/Alerts';
import UserNotificationsDataset from '../DataSets/UserNotifications/UserNotificationsDataset';
import DemoDataPackage from '../DataSets/DemoDataPackage/DemoDataPackage';
import SFMCQuickSearch from '../DataSets/SFMCQuickSearch/SFMCQuickSearch';
import SearchHomeMessage from '../DataSets/SFMCQuickSearch/SearchHomeMessage';
import Features from '../DataSets/Features/Features';
import SetTestToken from '../DataSets/SetTestToken/SetTestToken';
import AsanaTasks from '../DataSets/AsanaTasks/AsanaTasks';
import CreateInvoice from '../DataSets/CreateInvoice/CreateInvoice';
import SFMCUserOnboarding from '../DataSets/SFMCUserOnboarding/SFMCUserOnboarding';
import SFMCUserOffboarding from '../DataSets/SFMCUserOffboarding/SFMCUserOffboarding';
import StampDeal from '../DataSets/StampDeal/StampDeal';
import CurrencyRates from '../DataSets/CurrencyRates/CurrencyRates';
import Settings from '../DataSets/Settings/Settings';
import Tips from '../DataSets/Tips/Tips';

import AdminUsersAPI from '../../../api/adminusers';
import UsersAPI from '../../../api/users';
import OrganisationsAPI from '../../../api/organisations';
import ChangeLogsAPI from '../../../api/changelogs';
import SelectionRunLogsAPI from '../../../api/selectionRunLogs';
import NotificationsAPI from '../../../api/notifications';
import UserNotificationsAPI from '../../../api/user-notifications';

import Constants from '../../../constants/constants';

import './style.scss';
import Util from '../../../util';
import EngagementDashboard from '../DataSets/Engagement Dashboard/EngagementDashboard';
import EssentialsDashboard from '../DataSets/Engagement Dashboard/EssentialsDashboard';

const RightNav = () => {
  const menuContext = useContext(MenuContext);
  const [menuSelected] = menuContext.menuSelected;
  const [results, setResults] = useContext(ResultsContext);
  const [state, setState] = useContext(UtilsContext);
  const [refreshing, setRefreshing] = useState(false);
  const [newButtonDisabled, setNewButtonDisabled] = useState(false);

  /**
   * Validate an object so ensure no property is empty
   * @param {object} properties - The object to check
   * @returns {array} - All the errors `Please enter PROPERTY_NAME` as string
   */
  const validate = (properties) => {
    const errors = [];
    Object.entries(properties).forEach((property) => {
      if (String(property[1]).trim() === '') errors.push(`Please enter ${property[0]}`);
    });
    return errors;
  };

  /**
   * Handler called when click on the New button
   * @returns {void}
   */
  const handleNewButtonClicked = () => {
    setState({ ...state, isOpen: true, eventType: Constants.EVENT__TYPE__NEW });
  };

  /**
   * Handles the refreshing of DataSets
   * @returns {void}
   */
  const handleRefreshButtonClicked = async () => {
    // Set refresh state to true
    setRefreshing(true);
    const valuesToUpdate = {};
    if (menuSelected === Constants.MENU__NAME__CHANGELOG) {
      // Get data
      const res = await ChangeLogsAPI.getChangeLogs(null);
      valuesToUpdate.changeLogsData = res.data;
    } else if (menuSelected === Constants.MENU__NAME__SELECTION_RUN_LOG) {
      // Get data
      const res = await SelectionRunLogsAPI.getSelectionRunLogs(null);
      valuesToUpdate.selectionRunLogsData = res.data;
    } else if (menuSelected === Constants.MENU__NAME__SEGMENT_ORGANISATIONS) {
      // Get data
      const res = await OrganisationsAPI.getSegmentOrganisations(null);
      valuesToUpdate.segmentOrganisationsData = res;
    } else if (menuSelected === Constants.MENU__NAME__ENGAGE_ORGANISATIONS) {
      // Get data
      const res = await OrganisationsAPI.getEngageOrganisations(null);
      valuesToUpdate.engageOrganisationsData = res;
    } else if (menuSelected === Constants.MENU__NAME__ADMIN_USERS) {
      // Get data
      const res = await AdminUsersAPI.getAdminUsers(null);
      valuesToUpdate.adminUsersData = res.data;
    } else if (menuSelected === Constants.MENU__NAME__SEGMENT_USERS) {
      // Get data
      const res = await UsersAPI.getUsers(Constants.DESELECT_SEGMENT, null);
      const orgs = await OrganisationsAPI.getSegmentOrganisations(null);
      valuesToUpdate.segmentUsersData = res.users;
      valuesToUpdate.segmentOrganisationsData = orgs.data;
    } else if (menuSelected === Constants.MENU__NAME__ENGAGE_USERS) {
      // Get data
      const res = await UsersAPI.getUsers(Constants.DESELECT_ENGAGE, null);
      const orgs = await OrganisationsAPI.getEngageOrganisations(null);
      valuesToUpdate.engageUsersData = res.users;
      valuesToUpdate.engageOrganisationsData = orgs.data;
    } else if (menuSelected === Constants.MENU__NAME__NOTIFICATION) {
      // Get data
      const res = await NotificationsAPI.getNotifications(null);
      valuesToUpdate.notificationsData = res.data;
    } else if (menuSelected === Constants.MENU__NAME__ALERTS) {
      // Get data
      const res = await NotificationsAPI.getNotifications(null);
      valuesToUpdate.notificationsData = res.data;
    } else if (menuSelected === Constants.MENU__NAME__USER_NOTIFICATION) {
      // Get data
      const res = await UserNotificationsAPI.getUserNotifications(null);
      const notifications = await NotificationsAPI.getNotifications(null);
      const users = await UsersAPI.getUsers(Constants.DESELECT_SEGMENT, null);
      valuesToUpdate.userNotificationsData = res.data;
      valuesToUpdate.notificationsData = notifications.data;
      valuesToUpdate.segmentUsersData = users.users;
      setState({
        ...state,
        notifications: notifications.data,
        users: users.users,
      });
    }

    // Set data
    setResults({ ...results, ...valuesToUpdate });
    // Set refresh state to false
    setRefreshing(false);
  };

  /**
   * Render the NEW button if this function returns true
   * @returns {boolean} True if the NEW button should be rendered, false otherwise
   */
  const shouldRenderNewButton = () => (
    // CSM write permissions
    (
      Util.userHasPermission(
        Constants.USER__PERMISSION__CSM,
        Constants.USER__PERMISSION__WRITE,
      ) && (
        menuSelected === Constants.MENU__NAME__NOTIFICATION ||
          menuSelected === Constants.MENU__NAME__USER_NOTIFICATION ||
          menuSelected === Constants.MENU__NAME__TIPS ||
          menuSelected === Constants.MENU__NAME__ALERTS
      )) ||
      // Product write permissions
      (
        Util.userHasPermission(
          Constants.USER__PERMISSION__PRODUCT,
          Constants.USER__PERMISSION__WRITE,
        ) && (
          menuSelected === Constants.MENU__NAME__TIPS
        )) ||
      // Marketing write permissions
      (
        Util.userHasPermission(
          Constants.USER__PERMISSION__MARKETING,
          Constants.USER__PERMISSION__WRITE,
        ) && (
          menuSelected === Constants.MENU__NAME__TIPS
        )) ||
      // Setup write permissions
      (
        Util.userHasPermission(
          Constants.USER__PERMISSION__SETUP,
          Constants.USER__PERMISSION__WRITE,
        ) &&
        menuSelected === Constants.MENU__NAME__ADMIN_USERS
      )
  );

  /**
   * Render the Refresh button if this function returns true
   * @returns {boolean} True if the Refresh button should be rendered, false otherwise
   */
  const shouldRenderRefreshButton = () => (
    menuSelected !== Constants.MENU__NAME__DEMO_DATA_PACKAGE &&
    menuSelected !== Constants.MENU__NAME__FEATURE &&
    menuSelected !== Constants.MENU__NAME__SET_TEST_TOKEN &&
    menuSelected !== Constants.MENU__NAME__DASHBOARD &&
    menuSelected !== Constants.MENU__NAME__SEGMENT_ENGAGEMENT_DASHBOARD &&
    menuSelected !== Constants.MENU__NAME__ADOPTION_DASHBOARD &&
    menuSelected !== Constants.MENU__NAME__SFMC_QUICK_SEARCH &&
    menuSelected !== Constants.MENU__NAME__INTEGRATIONS &&
    menuSelected !== Constants.MENU__NAME__RELATIONS &&
    menuSelected !== Constants.MENU__NAME__ASANA_TASKS &&
    menuSelected !== Constants.MENU__NAME__SFMC_USER_SETUP &&
    menuSelected !== Constants.MENU__NAME__SFMC_OFFBOARDING &&
    menuSelected !== Constants.MENU__NAME__CREATE_INVOICE &&
    menuSelected !== Constants.MENU__NAME__STAMP_DEAL &&
    menuSelected !== Constants.MENU__NAME__SETTINGS &&
    menuSelected !== Constants.MENU__NAME__CURRENCY_RATES
  );

  return (
    <div style={{ display: menuSelected === '' ? 'none' : '' }}>
      {/* Menu Section */}
      <table
        className="slds-table slds-table_cell-buffer slds-table_bordered"
        style={{ marginBottom: '10px' }}
      >
        <thead>
          <tr>
            <th style={{ height: '40px' }}>{menuSelected}</th>
            <th style={{ textAlign: 'right', fontSize: '18px' }}>
              {/* Try alternative conditional syntax */}
              {shouldRenderNewButton() ?
                (
                  <button
                    type="button"
                    onClick={handleNewButtonClicked}
                    className="slds-button slds-button_brand"
                    style={{ width: '150px' }}
                    disabled={newButtonDisabled}
                  >
                    {menuSelected === Constants.MENU__NAME__ALERTS ? 'Create Alert' : 'New'}
                  </button>
                ) :
                null}
              {shouldRenderRefreshButton() && (
                <button
                  type="button"
                  className="slds-button slds-button_icon slds-button_icon-brand"
                  id="refresh-button"
                  onClick={handleRefreshButtonClicked}
                  title={`Refresh ${menuSelected}`}
                >
                  <svg
                    aria-hidden="true"
                    className={`slds-button__icon ${refreshing ?
                      'fa-spin' :
                      ''
                    }`}
                  >
                    <use xlinkHref="/assets/icons/utility-sprite/svg/symbols.svg#refresh" />
                  </svg>
                </button>
              )}
            </th>
          </tr>
        </thead>
      </table>

      {/* Menu Section */}

      {/* Dataset Section */}
      {menuSelected === Constants.MENU__NAME__DASHBOARD && <DashboardDataset />}
      {menuSelected === Constants.MENU__NAME__SEGMENT_ENGAGEMENT_DASHBOARD && <EngagementDashboard />}
      {menuSelected === Constants.MENU__NAME__SEGMENT_ESSENTIALS_ENGAGEMENT_DASHBOARD && <EssentialsDashboard />}
      {menuSelected === Constants.MENU__NAME__ADOPTION_DASHBOARD && <AdoptionDashboard />}
      {menuSelected === Constants.MENU__NAME__CHANGELOG && <ChangeLogsDataset />}
      {menuSelected === Constants.MENU__NAME__SELECTION_RUN_LOG && <SelectionRunLogsDataSet />}
      {menuSelected === Constants.MENU__NAME__SEGMENT_ORGANISATIONS && (
      <OrganisationsDataset
        product={Constants.DESELECT_SEGMENT}
      />
      )}
      {menuSelected === Constants.MENU__NAME__ENGAGE_ORGANISATIONS && (
      <OrganisationsDataset
        product={Constants.DESELECT_ENGAGE}
      />
      )}
      {menuSelected === Constants.MENU__NAME__ADMIN_USERS && <AdminUsersDataset validate={validate} />}
      {menuSelected === Constants.MENU__NAME__SEGMENT_USERS && (
        <UsersDataset
          product={Constants.DESELECT_SEGMENT}
        />
      )}
      {menuSelected === Constants.MENU__NAME__ENGAGE_USERS && (
        <UsersDataset
          product={Constants.DESELECT_ENGAGE}
        />
      )}
      {menuSelected === Constants.MENU__NAME__NOTIFICATION && <NotificationsDataset validate={validate} />}
      {menuSelected === Constants.MENU__NAME__ALERTS && <Alerts validate={validate} />}
      {menuSelected === Constants.MENU__NAME__USER_NOTIFICATION && <UserNotificationsDataset validate={validate} />}
      {menuSelected === Constants.MENU__NAME__TIPS && (
      <Tips
        validate={validate}
        setNewButtonDisabled={setNewButtonDisabled}
      />
      )}
      {menuSelected === Constants.MENU__NAME__SETTINGS && <Settings />}
      {menuSelected === Constants.MENU__NAME__DEMO_DATA_PACKAGE && <DemoDataPackage />}
      {menuSelected === Constants.MENU__NAME__SET_TEST_TOKEN && <SetTestToken />}
      {menuSelected === Constants.MENU__NAME__FEATURE && <Features />}
      {menuSelected === Constants.MENU__NAME__ASANA_TASKS && <AsanaTasks />}
      {menuSelected === Constants.MENU__NAME__CREATE_INVOICE && <CreateInvoice />}
      {menuSelected === Constants.MENU__NAME__SFMC_USER_SETUP && <SFMCUserOnboarding />}
      {menuSelected === Constants.MENU__NAME__SFMC_OFFBOARDING && <SFMCUserOffboarding />}
      {menuSelected === Constants.MENU__NAME__STAMP_DEAL && <StampDeal />}
      {menuSelected === Constants.MENU__NAME__CURRENCY_RATES && <CurrencyRates />}
      {menuSelected === Constants.MENU__NAME__SFMC_QUICK_SEARCH && <SFMCQuickSearch />}
      {menuSelected === Constants.MENU__NAME__SFMC_QUICK_SEARCH_HOME_MESSAGE && <SearchHomeMessage />}
      {/* Dataset Section */}
    </div>
  );
};
export default RightNav;
